import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import { doc, getDoc, updateDoc, setDoc, deleteDoc, collection, getDocs } from "firebase/firestore";
import gbsLogo from "./assets/gbs_logo_transparent.png";

export default function Profile() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({ naam: "", phone: "", area: "", username: "" });
  const [saving, setSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [error, setError] = useState("");
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const snap = await getDoc(doc(db, "users", auth.currentUser.uid));
        if (snap.exists()) {
          const data = snap.data();
          setUser(data);
          setForm({ naam: data.naam || "", phone: data.phone || "", area: data.area || "", username: data.username || "" });
        }
      } catch (err) { console.error(err); }
      setLoading(false);
    };
    const fetchCerts = async () => {
      try {
        const snap = await getDocs(collection(db, "certificates", auth.currentUser.uid, "items"));
        setCertificates(snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => b.issuedAt - a.issuedAt));
      } catch {}
    };
    fetchUser();
    fetchCerts();
  }, []);

  const handleSave = async () => {
    if (!form.naam.trim()) return;
    setError("");

    if (form.username && !/^[a-z0-9_]+$/.test(form.username)) {
      setError("Username mein sirf letters, numbers aur _ allowed hain!"); return;
    }

    const newUsername = form.username.toLowerCase();
    const oldUsername = user.username;
    const usernameChanged = newUsername && newUsername !== oldUsername;

    if (usernameChanged) {
      const snap = await getDoc(doc(db, "usernames", newUsername));
      if (snap.exists()) { setError("Yeh username pehle se le liya gaya hai!"); return; }
    }

    setSaving(true);
    try {
      const updates = { naam: form.naam.trim(), phone: form.phone.trim(), area: form.area.trim() };
      if (newUsername) updates.username = newUsername;

      await updateDoc(doc(db, "users", auth.currentUser.uid), updates);

      if (usernameChanged) {
        if (oldUsername) {
          await deleteDoc(doc(db, "usernames", oldUsername));
        }
        await setDoc(doc(db, "usernames", newUsername), {
          email: user.email,
          uid: auth.currentUser.uid,
        });
      }

      setUser(prev => ({ ...prev, ...updates }));
      setEditMode(false);
      setSuccessMsg("Profile update ho gaya!");
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) { console.error(err); }
    setSaving(false);
  };

  const loadImage = (src) => new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

  const buildCardCanvas = async () => {
    const canvas = document.createElement("canvas");
    canvas.width = 800; canvas.height = 450;
    const ctx = canvas.getContext("2d");

    const grad = ctx.createLinearGradient(0, 0, 800, 450);
    grad.addColorStop(0, "#0D1B3E"); grad.addColorStop(1, "#1A2F5A");
    ctx.fillStyle = grad; ctx.roundRect(0, 0, 800, 450, 20); ctx.fill();
    ctx.fillStyle = "#0D1B3E"; ctx.fillRect(0, 0, 8, 450);

    try {
      const logoImg = await loadImage(gbsLogo);
      ctx.globalAlpha = 0.95;
      ctx.drawImage(logoImg, 695, 20, 55, 55);
      ctx.globalAlpha = 1;
    } catch {
      // logo load fail ho toh silently skip — card baaki sahi bane
    }

    ctx.fillStyle = "rgba(255,255,255,0.5)"; ctx.font = "bold 18px Arial";
    ctx.fillText("GLOBAL BAHUUDESHIYA SANSTHA", 50, 60);
    ctx.fillStyle = "rgba(255,255,255,0.3)"; ctx.font = "14px Arial";
    ctx.fillText("Est. 2013 · Seva aur Vikas", 50, 85);

    ctx.strokeStyle = "rgba(255,255,255,0.1)"; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(50, 100); ctx.lineTo(750, 100); ctx.stroke();

    ctx.fillStyle = "rgba(255,255,255,0.15)";
    ctx.beginPath(); ctx.roundRect(50, 130, 140, 175, 10); ctx.fill();
    ctx.strokeStyle = "rgba(255,255,255,0.25)"; ctx.lineWidth = 1;
    ctx.strokeRect(50, 130, 140, 175);
    ctx.fillStyle = "#fff"; ctx.font = "bold 56px Arial"; ctx.textAlign = "center";
    ctx.fillText((user.naam || "?")[0].toUpperCase(), 120, 232);
    ctx.textAlign = "left";

    ctx.fillStyle = "#ffffff"; ctx.font = "bold 26px Arial";
    ctx.fillText(user.naam || "—", 50, 335);

    ctx.strokeStyle = "rgba(255,255,255,0.15)"; ctx.lineWidth = 1;
    ctx.strokeRect(500, 130, 240, 280);
    ctx.fillStyle = "rgba(255,255,255,0.4)"; ctx.font = "12px Arial"; ctx.textAlign = "center";
    ctx.fillText("MEMBER ID", 620, 165);
    ctx.fillStyle = "#fff"; ctx.font = "bold 26px Arial";
    const memberId = user.membershipId || `GBS-${auth.currentUser.uid.slice(0, 8).toUpperCase()}`;
    ctx.fillText(memberId, 620, 200);

    ctx.fillStyle = "rgba(255,255,255,0.4)"; ctx.font = "12px Arial";
    ctx.fillText("DESIGNATION", 620, 235);
    ctx.fillStyle = "#fff"; ctx.font = "bold 15px Arial";
    ctx.fillText((user.role || "MEMBER").replace(/_/g, " ").toUpperCase(), 620, 257);

    ctx.fillStyle = "rgba(255,255,255,0.4)"; ctx.font = "12px Arial";
    ctx.fillText("JOINED", 620, 292);
    ctx.fillStyle = "#fff"; ctx.font = "bold 15px Arial";
    ctx.fillText(user.createdAt ? new Date(user.createdAt).getFullYear() : "2024", 620, 314);
    ctx.fillStyle = "rgba(255,255,255,0.3)"; ctx.font = "12px Arial";
    ctx.fillText("globasa-519f1.web.app", 620, 380);
    ctx.textAlign = "left";

    return canvas;
  };

  const downloadCard = async () => {
    const canvas = await buildCardCanvas();
    const link = document.createElement("a");
    link.download = `GBS_MemberCard_${user.naam?.replace(/\s/g, "_")}.png`;
    link.href = canvas.toDataURL("image/png");
    link.click();
  };

  const shareOnWhatsApp = async () => {
    const canvas = await buildCardCanvas();
    const memberId = user.membershipId || `GBS-${auth.currentUser.uid.slice(0, 8).toUpperCase()}`;

    canvas.toBlob(async (blob) => {
      const file = new File([blob], `GBS_ID_${user.naam?.replace(/\s/g, "_")}.png`, { type: "image/png" });
      const shareText = `Mera GBS Member ID Card — ${memberId}\nGlobal Bahuudeshiya Sanstha`;

      if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
        try {
          await navigator.share({ files: [file], title: "GBS Member ID Card", text: shareText });
          return;
        } catch {
          // user cancelled — fall through to link fallback
        }
      }

      const link = document.createElement("a");
      link.download = `GBS_ID_${user.naam?.replace(/\s/g, "_")}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();

      const waText = encodeURIComponent(shareText + "\n\n(ID card image abhi download hui hai — usse attach karein)");
      window.open(`https://wa.me/?text=${waText}`, "_blank");
    }, "image/png");
  };

  if (loading) return <p style={{ textAlign: "center", color: "#9CA3AF", padding: 40, fontSize: 13 }}>Loading...</p>;
  if (!user) return <div style={{ textAlign: "center", padding: 40 }}><p style={{ color: "#9CA3AF" }}>Profile data not found.</p></div>;

  const memberId = user.membershipId || `GBS-${auth.currentUser.uid.slice(0, 8).toUpperCase()}`;
  const followersCount = (user.followers || []).length;
  const followingCount = (user.following || []).length;

  return (
    <div>
      <div style={styles.headerCard}>
        <div style={styles.avatar}>{(user.naam || "?")[0].toUpperCase()}</div>
        <h2 style={styles.name}>{user.naam}</h2>
        {user.username && <p style={styles.username}>@{user.username}</p>}
        <p style={styles.email}>{user.email}</p>
        <span style={styles.badge}>{user.role ? user.role.replace(/_/g, " ").toUpperCase() : "MEMBER"}</span>
        <div style={styles.statsRow}>
          <div style={styles.statBox}><p style={styles.statNum}>{followersCount}</p><p style={styles.statLabel}>Followers</p></div>
          <div style={styles.statDivider} />
          <div style={styles.statBox}><p style={styles.statNum}>{followingCount}</p><p style={styles.statLabel}>Following</p></div>
          <div style={styles.statDivider} />
          <div style={styles.statBox}><p style={styles.statNum}>{certificates.length}</p><p style={styles.statLabel}>Certificates</p></div>
        </div>
      </div>

      <div style={styles.section}>
        <p style={styles.sectionLabel}>Member ID Card</p>
        <div style={styles.idCardPreview}>
          <img src={gbsLogo} alt="GBS" style={styles.idCardLogoBadge} />
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <p style={styles.idCardOrg}>GLOBAL BAHUUDESHIYA SANSTHA</p>
            <p style={styles.idCardEst}>Est. 2013 · Seva aur Vikas</p>
            <div style={styles.idAvatarBlock}>
              <div style={styles.idAvatar}>{(user.naam || "?")[0].toUpperCase()}</div>
              <p style={styles.idName}>{user.naam}</p>
            </div>
          </div>
          <div style={styles.idCardRight}>
            <p style={styles.idCardLabel}>MEMBER ID</p>
            <p style={styles.idCardNum}>{memberId}</p>
            <p style={styles.idCardLabel}>DESIGNATION</p>
            <p style={styles.idCardVal}>{(user.role || "MEMBER").replace(/_/g, " ").toUpperCase()}</p>
            <p style={styles.idCardLabel}>STATUS</p>
            <p style={styles.idCardVal}>{user.membershipStatus === "active" ? "Active" : "Pending"}</p>
            <p style={styles.idCardLabel}>CITY</p>
            <p style={styles.idCardVal}>{user.city || "—"}</p>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={downloadCard} style={styles.downloadBtn}>Download ID Card</button>
          <button onClick={shareOnWhatsApp} style={styles.whatsappBtn}>
            <WhatsAppIcon /> Share
          </button>
        </div>
      </div>

      {certificates.length > 0 && (
        <div style={styles.section}>
          <p style={styles.sectionLabel}>Mere Certificates ({certificates.length})</p>
          <div style={styles.card}>
            {certificates.map((c, i) => (
              <div key={c.id} style={{ ...styles.certRow, borderBottom: i < certificates.length - 1 ? "1px solid #ECECEE" : "none" }}>
                <div style={styles.certIconBox}>
                  <CertificateIcon />
                </div>
                <div style={{ flex: 1 }}>
                  <p style={styles.certType}>{c.type}</p>
                  {c.reason && <p style={styles.certReason}>{c.reason}</p>}
                  <p style={styles.certDate}>{new Date(c.issuedAt).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {successMsg && <div style={styles.successBox}>{successMsg}</div>}

      {!user.username && !editMode && (
        <div style={styles.usernameBanner}>
          <p style={{ margin: 0, fontSize: 12, color: "#92400E" }}>Username set nahi kiya!</p>
          <button onClick={() => setEditMode(true)} style={styles.setBtnSmall}>Set Karo</button>
        </div>
      )}

      {!editMode ? (
        <>
          <div style={styles.section}>
            <p style={styles.sectionLabel}>Details</p>
            <div style={styles.card}>
              {[
                { label: "Member ID", value: memberId },
                { label: "Username", value: user.username ? `@${user.username}` : "Set nahi hua" },
                { label: "Phone", value: user.phone },
                { label: "State", value: user.state },
                { label: "District", value: user.district },
                { label: "City", value: user.city },
                { label: "Area", value: user.area || "—" },
                { label: "Role", value: user.role ? user.role.replace(/_/g, " ").toUpperCase() : "MEMBER" },
                { label: "Membership", value: user.membershipStatus === "pending" ? "Payment Pending" : "Active" },
              ].map((item, i, arr) => (
                <div key={item.label} style={{ ...styles.row, borderBottom: i < arr.length - 1 ? "1px solid #ECECEE" : "none" }}>
                  <span style={styles.rowLabel}>{item.label}</span>
                  <span style={styles.rowValue}>{item.value}</span>
                </div>
              ))}
            </div>
          </div>
          <button onClick={() => setEditMode(true)} style={styles.editBtn}>Profile Edit Karein</button>
        </>
      ) : (
        <div style={styles.editForm}>
          <p style={styles.editTitle}>Profile Edit Karein</p>
          <label style={styles.label}>Poora Naam</label>
          <input style={styles.input} value={form.naam} onChange={e => setForm(p => ({ ...p, naam: e.target.value }))} />
          <label style={styles.label}>Username</label>
          <input style={styles.input} value={form.username} onChange={e => setForm(p => ({ ...p, username: e.target.value.toLowerCase() }))} placeholder="username_123" />
          <label style={styles.label}>Phone</label>
          <input style={styles.input} value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} />
          <label style={styles.label}>Area / Ward</label>
          <input style={styles.input} value={form.area} onChange={e => setForm(p => ({ ...p, area: e.target.value }))} />
          {[{ label: "State", value: user.state }, { label: "City", value: user.city }].map(item => (
            <div key={item.label}>
              <label style={styles.label}>{item.label} (change nahi hoga)</label>
              <div style={styles.readOnly}>{item.value}</div>
            </div>
          ))}
          {error && <p style={{ color: "#DC2626", fontSize: 12, marginBottom: 10 }}>{error}</p>}
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={() => { setEditMode(false); setError(""); }} style={styles.cancelBtn}>Cancel</button>
            <button onClick={handleSave} disabled={saving || !form.naam.trim()} style={{ ...styles.saveBtn, opacity: !form.naam.trim() ? 0.5 : 1 }}>
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      )}

      <div style={styles.depositBox}>
        <p style={styles.depositTitle}>Membership Fee Breakdown</p>
        <p style={styles.depositText}>Membership Fee: ₹300 (non-refundable)</p>
        <p style={styles.depositText}>Security Deposit: ₹700 (refundable)</p>
        <p style={styles.depositText}>Total: ₹1000/year</p>
      </div>
    </div>
  );
}

function WhatsAppIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 6 }}>
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm5.83 13.96c-.24.69-1.41 1.32-1.95 1.4-.5.08-1.12.11-1.81-.11-.42-.13-.95-.31-1.64-.6-2.87-1.24-4.74-4.16-4.89-4.35-.14-.19-1.17-1.55-1.17-2.96 0-1.41.74-2.1 1-2.39.26-.29.57-.36.76-.36.19 0 .38 0 .55.01.18.01.41-.07.64.49.24.57.81 1.97.88 2.11.07.15.12.32.02.51-.09.19-.14.31-.28.48-.14.17-.29.37-.42.5-.14.14-.28.29-.12.57.16.28.71 1.17 1.52 1.9 1.05.94 1.93 1.23 2.21 1.37.28.14.44.12.6-.07.16-.19.69-.8.87-1.08.18-.28.36-.23.6-.14.24.09 1.54.73 1.81.86.27.14.45.2.51.32.07.12.07.68-.17 1.36z"/>
    </svg>
  );
}

function CertificateIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="6" /><path d="M9 14l-2 7 5-3 5 3-2-7" />
    </svg>
  );
}

const styles = {
  headerCard: { background: "linear-gradient(135deg, #0D1B3E, #1A2F5A)", borderRadius: 20, padding: "28px 20px", textAlign: "center", marginBottom: 16 },
  avatar: { width: 56, height: 56, background: "rgba(255,255,255,0.12)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 22, fontWeight: 700, margin: "0 auto 10px" },
  name: { color: "#fff", margin: "0 0 2px", fontSize: 19, fontWeight: 700 },
  username: { color: "rgba(255,255,255,0.5)", fontSize: 12, margin: "0 0 4px" },
  email: { color: "rgba(255,255,255,0.4)", margin: 0, fontSize: 11 },
  badge: { display: "inline-block", marginTop: 10, background: "rgba(255,255,255,0.12)", color: "#fff", fontSize: 10, fontWeight: 700, padding: "4px 14px", borderRadius: 20, letterSpacing: 0.5 },
  statsRow: { display: "flex", justifyContent: "center", alignItems: "center", gap: 16, marginTop: 16 },
  statBox: { textAlign: "center" },
  statNum: { margin: 0, fontSize: 18, fontWeight: 700, color: "#fff" },
  statLabel: { margin: 0, fontSize: 10, color: "rgba(255,255,255,0.45)" },
  statDivider: { width: 1, height: 28, background: "rgba(255,255,255,0.15)" },
  section: { marginBottom: 14 },
  sectionLabel: { margin: "0 0 10px 4px", fontSize: 12, fontWeight: 700, color: "#9CA3AF", textTransform: "uppercase", letterSpacing: 0.5 },
  card: { background: "#fff", borderRadius: 16, padding: 0, border: "1px solid #ECECEE", overflow: "hidden" },
  idCardPreview: { position: "relative", background: "linear-gradient(135deg, #0D1B3E, #1A2F5A)", borderRadius: 16, padding: 16, display: "flex", gap: 12, marginBottom: 10 },
  idCardLogoBadge: { position: "absolute", top: 10, right: 10, width: 32, height: 32, objectFit: "contain", opacity: 0.9 },
  idCardOrg: { margin: "0 0 2px", fontSize: 9, fontWeight: 700, color: "rgba(255,255,255,0.45)", letterSpacing: 1 },
  idCardEst: { margin: "0 0 12px", fontSize: 9, color: "rgba(255,255,255,0.3)" },
  idAvatarBlock: { display: "flex", flexDirection: "column", gap: 8, alignItems: "flex-start" },
  idAvatar: { width: 68, height: 84, borderRadius: 8, background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.25)", color: "#fff", fontSize: 26, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  idName: { margin: 0, fontSize: 16, fontWeight: 700, color: "#fff" },
  idCardRight: { width: 110, background: "rgba(255,255,255,0.06)", borderRadius: 10, padding: "10px 8px" },
  idCardLabel: { margin: "0 0 2px", fontSize: 9, color: "rgba(255,255,255,0.4)", letterSpacing: 1 },
  idCardNum: { margin: "0 0 10px", fontSize: 13, fontWeight: 800, color: "#fff" },
  idCardVal: { margin: "0 0 10px", fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.85)" },
  downloadBtn: { flex: 1, padding: 13, background: "#0D1B3E", color: "#fff", border: "none", borderRadius: 12, fontSize: 13, fontWeight: 600, cursor: "pointer" },
  whatsappBtn: { flex: 1, padding: 13, background: "#25D366", color: "#fff", border: "none", borderRadius: 12, fontSize: 13, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
  certRow: { display: "flex", gap: 12, alignItems: "flex-start", padding: "14px 16px" },
  certIconBox: { width: 32, height: 32, background: "#0D1B3E", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  certType: { margin: "0 0 2px", fontSize: 13, fontWeight: 600, color: "#0D1B3E" },
  certReason: { margin: "0 0 4px", fontSize: 12, color: "#6B7280" },
  certDate: { margin: 0, fontSize: 11, color: "#9CA3AF" },
  usernameBanner: { background: "#FFFBEB", border: "1px solid #FDE68A", borderRadius: 12, padding: "12px 14px", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 },
  setBtnSmall: { background: "#0D1B3E", color: "#fff", border: "none", borderRadius: 8, padding: "6px 12px", fontSize: 11, fontWeight: 600, cursor: "pointer" },
  row: { padding: "13px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" },
  rowLabel: { fontSize: 13, color: "#9CA3AF" },
  rowValue: { fontSize: 13, fontWeight: 600, color: "#0D1B3E" },
  successBox: { background: "#F0FDF4", border: "1px solid #BBF7D0", borderRadius: 10, padding: "10px 14px", marginBottom: 12, fontSize: 13, color: "#16A34A", fontWeight: 600, textAlign: "center" },
  editBtn: { width: "100%", padding: 13, background: "#0D1B3E", color: "#fff", border: "none", borderRadius: 12, fontSize: 13, fontWeight: 600, cursor: "pointer", marginBottom: 14 },
  editForm: { background: "#fff", borderRadius: 16, padding: 18, marginBottom: 14, border: "1px solid #ECECEE" },
  editTitle: { margin: "0 0 14px", fontSize: 14, fontWeight: 700, color: "#0D1B3E" },
  label: { display: "block", fontSize: 11, fontWeight: 600, color: "#9CA3AF", marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.5 },
  input: { width: "100%", padding: "11px 12px", borderRadius: 10, border: "1px solid #ECECEE", fontSize: 13, marginBottom: 12, boxSizing: "border-box", outline: "none", background: "#FAFAFA" },
  readOnly: { background: "#F7F7F9", borderRadius: 10, padding: "11px 12px", fontSize: 13, color: "#9CA3AF", marginBottom: 12 },
  cancelBtn: { flex: 1, padding: 12, background: "#F7F7F9", color: "#374151", border: "none", borderRadius: 10, fontSize: 13, fontWeight: 600, cursor: "pointer" },
  saveBtn: { flex: 2, padding: 12, background: "#0D1B3E", color: "#fff", border: "none", borderRadius: 10, fontSize: 13, fontWeight: 600, cursor: "pointer" },
  depositBox: { background: "#F7F7F9", borderRadius: 14, padding: "16px 18px", marginTop: 4 },
  depositTitle: { margin: "0 0 8px", fontSize: 12, fontWeight: 700, color: "#9CA3AF", textTransform: "uppercase", letterSpacing: 0.5 },
  depositText: { margin: "4px 0", fontSize: 13, color: "#374151" },
};